import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopMembers } from 'src/services/Scope.client';

export interface SettingsState {
  isCompanionCollapsed: boolean;
  lastScopeCreated: Record<string, TopMembers>;
  isMfpPivotCollapsed: boolean;
  isMfpMacroSummariesCollapsed: boolean;
}

const initialState: SettingsState = {
  isCompanionCollapsed: false,
  lastScopeCreated: {} as Record<string, TopMembers>,
  isMfpPivotCollapsed: false,
  isMfpMacroSummariesCollapsed: false,
};

const uiPoseSlice = createSlice({
  name: 'uiPose',
  initialState: initialState,
  reducers: {
    setLastScopeCreated: (state, action: PayloadAction<[string, TopMembers]>) => {
      state.lastScopeCreated[action.payload[0]] = action.payload[1];
    },
    toggleCompanionCollapse: (state) => {
      state.isCompanionCollapsed = !state.isCompanionCollapsed;
    },
    setMfpPivotCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isMfpPivotCollapsed = action.payload;
    },
    setMfpMacroSummariesCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isMfpMacroSummariesCollapsed = action.payload;
    },
  },
});

export const { setLastScopeCreated, toggleCompanionCollapse, setMfpPivotCollapsed, setMfpMacroSummariesCollapsed } = uiPoseSlice.actions;

export default uiPoseSlice.reducer;
